import { createI18n } from 'vue-i18n'
import en from './en.json'
import de from './de.json'

const savedLocale = localStorage.getItem('locale')

const i18n = createI18n({
  legacy: false,
  locale: savedLocale || 'de',
  fallbackLocale: 'en',
  messages: {
    en,
    de
  }
})

export default i18n
